module.exports = __webpack_public_path__ + "static/NeueMontreal-Regular-30e7f2fa0be0cde9db7d25ccdd61065e.woff";